export const onDependEmptyField = (dependentField, formkey, dispatch, setAllFieldsData, mainField) => {
 
  dispatch({
    type: "StoreMasterData",
    payload: {
      formkey: formkey,
      data: {
        [dependentField]: {},
      },
    },
  });
};
